module.exports = "<button ng-show=closeable type=button class=close ng-click=\"close({$event: $event})\"> <span aria-hidden=true>&times;</span> <span class=sr-only translate>Close</span> </button> <div><b translate>Attention!</b> <span ng-transclude></span></div>";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/messages/alert_partial.html
// module id = 418
// module chunks = 0